import { useState } from 'react'
import { UNITES_VENTE } from './wizardConstants'

/**
 * Proposer un produit, ecran 4 : « Vous le vendez… »
 * (prototype v7.4, WizardOffre/prop.unite). Cinq unites en toutes lettres, un
 * champ « Autre » + OK ; toucher une unite la choisit ET termine la proposition,
 * qui rejoint alors le wizard (canaux, prix, type, stock) comme un produit du
 * referentiel — la reference part en validation Manrina avec l'offre.
 */
function StepProposeUnite({ onChoisir }) {
  const [autre, setAutre] = useState('')
  const autreOk = autre.trim().length > 0
  // « le sachet » → « sachet » : on garde l'unite, pas l'article (prototype).
  const normaliser = (u) => u.trim().replace(/^l[ae]s?\s+/i, '').replace(/^l'/i, '')

  return (
    <div>
      <div className="flex flex-col gap-2">
        {UNITES_VENTE.map((u) => (
          <button
            key={u.value}
            onClick={() => onChoisir(u.value)}
            className="panneau-verre rounded-2xl px-[15px] py-[13px] text-sm font-bold text-ink text-left"
            style={{ border: '1px solid rgba(7,62,61,0.08)' }}
          >
            {u.label}
          </button>
        ))}
        <div className="flex gap-2">
          <input
            value={autre}
            onChange={(e) => setAutre(e.target.value)}
            placeholder="Autre (ex. le sachet)"
            className="flex-1 min-w-0 rounded-2xl px-3.5 py-3 text-base text-ink outline-none"
            style={{ background: 'rgba(255,255,255,0.6)', border: '1px solid rgba(7,62,61,0.12)' }}
          />
          <button
            disabled={!autreOk}
            onClick={() => onChoisir(normaliser(autre))}
            className="rounded-2xl px-[18px] text-[13px] font-extrabold flex-shrink-0"
            style={autreOk
              ? { background: 'rgb(var(--c-green))', color: 'rgb(var(--c-creme))' }
              : { background: 'rgba(7,62,61,0.15)', color: 'rgb(var(--c-creme))' }}
          >
            OK
          </button>
        </div>
      </div>
      <p className="text-[11px] text-ink/50 mt-3 leading-[1.45]">
        Votre proposition passera en validation Manrina (anti-doublon final) avant d'entrer au référentiel.
      </p>
    </div>
  )
}

export default StepProposeUnite
